import { nowUtcIso } from '@/lib/dates'
import { newUuid } from '@/offline/queue'
import type { Payment } from '@/offline/types'

export interface PaymentInput {
  workspace_id: string
  sale_id: string
  amount_paisa: number
  method?: string | null
  paid_at?: string
}

export interface BuiltPayment {
  payment: Payment
  payload: Record<string, unknown>
}

/** Build a partial-receipt payment against a sale (direction 'in'). */
export function buildPayment(input: PaymentInput): BuiltPayment {
  const now = nowUtcIso()
  const payment: Payment = {
    workspace_id: input.workspace_id,
    id: newUuid(),
    direction: 'in',
    amount_paisa: input.amount_paisa,
    related_type: 'sale',
    related_id: input.sale_id,
    method: input.method ?? null,
    paid_at: input.paid_at ?? now,
    notes: null,
    revision: 1,
    created_at: now,
    updated_at: now,
    deleted_at: null,
  }
  const payload: Record<string, unknown> = {
    direction: 'in',
    amount_paisa: payment.amount_paisa,
    related_type: 'sale',
    related_id: payment.related_id,
    method: payment.method,
    paid_at: payment.paid_at,
  }
  return { payment, payload }
}
